

































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskLevelForScore, RiskTextForScore } from "@/model/Model";
import { UpdatedHeight } from "@/utils";
import { Borough } from "@/model/Boroughs";
import UnitsExplanation from "./UnitsExplanation.vue";
import RisksAnalysis from "./RisksAnalysis.vue";
import DrinkingComparison from "./DrinkingComparison.vue";
import AmIAlcoholic from "./AmIAlcoholic.vue";
import PregnancyAdvice from "./PregnancyAdvice.vue";
import DrinkDrivingAdvice from "./DrinkDrivingAdvice.vue";
import { RiskLevel } from "@/model/RiskLevel";

@Component({
  components: {
    AmIAlcoholic,
    UnitsExplanation,
    RisksAnalysis,
    DrinkingComparison,
    PregnancyAdvice,
    DrinkDrivingAdvice
  }
})
export default class MoreAboutYourDrinking extends Vue {
  public static navButtonClasses: string[] = ["more-about-drinking"];
  public static navButtonLabel: () => string = () =>
    "Read more about your drinking";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() private isMobile!: boolean;

  public updated() {
    UpdatedHeight();
  }

  private get isCommissioned(): boolean {
    return !(["Other", "NorthEastAndNorthCumbria"].includes(this.region.name));
  }

  private get isHighRisk(): boolean {
    const riskLevel = RiskLevelForScore(this.score);
    return riskLevel === RiskLevel.Higher || riskLevel === RiskLevel.High;
  }

  private get isIncreasingRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Increasing;
  }

  private get riskText(): string {
    return RiskTextForScore(this.score);
  }

  private get isFemale(): boolean {
    return this.gender === Gender.Female;
  }
}
